import $ from 'jquery';
import Faye from 'faye/src/faye_browser';

const fayeClients = new Map();

export function withFayeClient(fn) {
  if (window.reactor?.client) {
    fn(window.reactor?.client);
  } else {
    $(window).one('faye:init', (event, client) => fn(client));
  }
}

function createFayeClient({
  url = window.Configatron.live.url,
  tokens = null,
} = {}) {
  const key = JSON.stringify([url, tokens]);
  if (fayeClients.get(key)) return fayeClients.get(key);

  const AUTO_DISCONNECT_TIMEOUT = 1000 * 60 * 60 * 8;
  const FAYE_CONNECT_TIMEOUT = 25;
  const client = new Faye.Client(url, {
    timeout: FAYE_CONNECT_TIMEOUT,
  });

  client.onSubscriptionAuthenticationFailure = callback => {
    client.subscriptionAuthenticationFailureCallbacks =
      client.subscriptionAuthenticationFailureCallbacks || [];
    client.subscriptionAuthenticationFailureCallbacks.push(callback);
  };

  client.performAutoDisconnect = () => {
    client.disconnect();

    // Prevent turbolinks loads - so that subsequent full page loads reconnect
    // to faye.
    $('body').attr('data-no-turbolink', 'true');

    $(window).trigger('faye:disconnect');
  };

  client.autoDisconnect = function () {
    window.clearTimeout(this.disconnector);
    this.disconnector = window.setTimeout(
      this.performAutoDisconnect,
      AUTO_DISCONNECT_TIMEOUT
    );
  };

  client.autoDisconnect();
  $(document).on('mousemove', () => {
    client.autoDisconnect();
  });

  client.addExtension({
    outgoing: (message, callback) => {
      if (message.channel === '/meta/subscribe') {
        message.ext = {};
        if (message.subscription.match(/\/messages\/listen/)) {
          message.ext.token = $('meta[name=dm-token]').attr('content');
        } else if (message.subscription.match(/\/editing_tracker\/listen/)) {
          message.ext.token = $('meta[name=editing_tracker-token]').attr(
            'content'
          );
        } else if (message.subscription.match(/\/reactive\/listen/)) {
          message.ext.token = $('meta[name=reactive-token]').attr('content');
        } else if (message.subscription.match(/\/ai_agents\//)) {
          const tokenAndExpiry = $('meta[name=ai-agents-token]')
            .attr('content')
            ?.split('-');
          if (!tokenAndExpiry) {
            console.error(
              'No token found for AI agents. Please check the meta tag.'
            );
          } else {
            const token = tokenAndExpiry[0];
            const expiry = parseFloat(tokenAndExpiry[1]);
            message.ext.token = token;
            message.ext.token_expiry = expiry;
          }
        } else if (
          message.subscription.match(/\/shared-reactive\/listen/) &&
          tokens?.sharedReactive
        ) {
          message.ext.token = tokens.sharedReactive;
        } else if (message.subscription.match(/\/selections\//)) {
          message.ext.token =
            tokens?.collaborativeSelection ||
            $('meta[name=collaborative-selection-token]').attr('content');
        }
      } else if (message.channel.startsWith('/selections/')) {
        message.ext = {};
        message.ext.token =
          tokens?.collaborativeSelection ||
          $('meta[name=collaborative-selection-token]').attr('content');
      }
      callback(message);
    },
    incoming: (message, callback) => {
      if (message.channel === '/meta/subscribe') {
        if (!message.successful) {
          client.subscriptionAuthenticationFailureCallbacks?.forEach(cb =>
            cb(message)
          );
        }
      }
      callback(message);
    },
  });

  fayeClients.set(key, client);
  if (url === window.Configatron.live.url && !tokens) {
    window.fayeClient = client;
  }
  return client;
}

export { createFayeClient };
